// Full menu — sourced from the official Udupi Paakamane menu card.
export const RESTAURANT = {
  name: "Udupi Paakamane",
  nameKannada: "ಉಡುಪಿ ಪಾಕಮನೆ",
  tagline: "Pure Veg Cafe",
  phone: "+91 80 3119 5752",
  addressLines: [
    "825/1, Ground Floor, 14th Main Road",
    "Between Maruthi Circle & Sri Shaneshwara Swamy Temple",
    "Hanumanthanagar, Bengaluru – 560019",
  ],
  mapsQuery:
    "Udupi+Paakamane,+14th+Main+Road,+Hanumanthanagar,+Bengaluru,+Karnataka+560019",
  hours: "6:30 AM – 9:15 PM",
  hoursNote: "Open all seven days",
  instagram: "https://www.instagram.com/udupi_paakamane",
  googleRating: 4.4,
  googleReviewCount: 20,
};

export const MENU = [
  {
    id: "rice",
    title: "Tiffin & Rice",
    titleKannada: "ತಿಂಡಿ ಮತ್ತು ರೈಸ್ ಖಾದ್ಯಗಳು",
    note: "Steamed, tempered, served with sambar & chutney",
    items: [
      { name: "Idli", desc: "Soft steamed rice cakes" },
      { name: "Rava Idli", desc: "Semolina & cashew idli" },
      { name: "Tatte Idli", desc: "Single plate idli" },
      { name: "Idli Vada", desc: "Idli with a crisp vada" },
      { name: "Uddina Vade", desc: "Crisp urad dal vada" },
      { name: "Rice Bath of the Day", desc: "Bisibele / vaangi / tomato / pudina" },
      { name: "Pulao of the Day", desc: "Veg or mushroom" },
      { name: "Ghee Rice", desc: "Fragrant ghee rice" },
      { name: "South Indian Meals", desc: "Full traditional thali" },
    ],
  },
  {
    id: "dose",
    title: "Dose",
    titleKannada: "ದೋಸೆ",
    note: "Griddle-fresh, off the tava",
    items: [
      { name: "Plain Dose", desc: "Classic crisp dose" },
      { name: "Set Dose", desc: "Soft, spongy set" },
      { name: "Masala Dose", desc: "With potato palya" },
      { name: "Rava Dose", desc: "Lacy semolina dose" },
      { name: "Onion Dose", desc: "Loaded with onions" },
      { name: "Raagi Dose", desc: "Finger millet dose" },
      { name: "Khali Dose", desc: "Plain set dose" },
      { name: "Mangaluru Buns", desc: "Sweet banana buns" },
    ],
  },
  {
    id: "specials",
    title: "House Specials",
    titleKannada: "ಇತರೆ",
    note: "The everyday favourites",
    items: [
      { name: "Khara Bath", desc: "Savoury upma" },
      { name: "Kesari Bath", desc: "Sweet semolina" },
      { name: "Rice Bath", desc: "Spiced rice of the day" },
      { name: "Dose and Idli", desc: "The classic combo plate" },
    ],
  },
  {
    id: "chinese",
    title: "Indo-Chinese",
    titleKannada: "ಚೈನೀಸ್",
    note: "Served from 2:30 PM onwards",
    items: [
      { name: "Gobi Manchurian", desc: "Cauliflower, classic" },
      { name: "Mushroom Manchurian", desc: "" },
      { name: "Baby Corn Manchurian", desc: "" },
      { name: "Paneer Manchurian", desc: "" },
      { name: "Paneer Chilli", desc: "" },
      { name: "Chilli Mushroom", desc: "" },
      { name: "Honey Chilli Potato", desc: "" },
      { name: "Crispy Chilli Baby Corn", desc: "" },
      { name: "French Fries", desc: "" },
      { name: "Peri Peri French Fries", desc: "" },
      { name: "Veg Fried Rice", desc: "" },
      { name: "Schezwan Fried Rice", desc: "" },
      { name: "Burnt Garlic Fried Rice", desc: "" },
      { name: "Chilli Garlic Fried Rice", desc: "" },
      { name: "Hakka Noodles", desc: "" },
      { name: "Schezwan Noodles", desc: "" },
      { name: "Chilli Garlic Noodles", desc: "" },
      { name: "Burnt Garlic Noodles", desc: "" },
    ],
  },
  {
    id: "beverages",
    title: "Filter Coffee & Tea",
    titleKannada: "ಪಾನೀಯಗಳು",
    note: "Brewed the traditional way",
    items: [
      { name: "Filter Coffee", desc: "Decoction & frothed milk" },
      { name: "Tea", desc: "Hot masala chai" },
    ],
  },
];

export const IMAGES = {
  heroDosa:
    "https://images.pexels.com/photos/5560763/pexels-photo-5560763.jpeg?auto=compress&cs=tinysrgb&w=1400",
  cooking:
    "https://images.pexels.com/photos/9986228/pexels-photo-9986228.jpeg?auto=compress&cs=tinysrgb&w=1400",
  idli:
    "https://images.pexels.com/photos/4331491/pexels-photo-4331491.jpeg?auto=compress&cs=tinysrgb&w=1200",
  dose:
    "https://images.unsplash.com/photo-1708146464361-5c5ce4f9abb6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  specials:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_udupi-paakamane/artifacts/4rs8i3hp_ChatGPT%20Image%20Aug%2026%2C%202026%20at%2002_08_14%20PM.png",
  chinese:
    "https://images.pexels.com/photos/2456435/pexels-photo-2456435.jpeg?auto=compress&cs=tinysrgb&w=1200",
  coffee:
    "https://images.unsplash.com/photo-1521677633993-721dd3f95c10?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const NAV_LINKS = [
  { id: "about", label: "About" },
  { id: "menu", label: "Menu" },
  { id: "visit", label: "Visit" },
];
